<template>
  <div class="product-display">
    <!-- 顶部筛选区域 -->
    <el-row class="filter-bar" justify="center" v-if="!showDetail">
      <el-col :span="20">
        <div class="filter-container">
          <!-- 分类标签 -->
          <div class="categories">
            <el-button
              v-for="category in categories"
              :key="category"
              type="text"
              :class="{ active: selectedCategory === category }"
              @click="filterByCategory(category)"
            >
              {{ category }}
            </el-button>
          </div>

          <!-- 子分类和搜索（融合在一个框中） -->
          <div class="search-tools">
            <el-input
              v-model="searchQuery"
              placeholder="搜索..."
              class="search-input-group"
            >
              <template #prepend>
                <el-select
                  v-model="selectedSubCategory"
                  placeholder="子分类"
                  style="width: 80px"
                >
                  <el-option
                    v-for="subCategory in subCategories"
                    :key="subCategory"
                    :label="subCategory"
                    :value="subCategory"
                  />
                </el-select>
              </template>
            </el-input>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 产品展示区域 -->
    <el-row :gutter="32" class="product-grid" v-if="!showDetail">
      <el-col
        v-for="product in pagedProducts"
        :key="product.subDescription"
        :xs="24"
        :sm="12"
        :md="8"
        :lg="6"
      >
        <el-card shadow="hover" class="product-card">
          <div class="product-image" :style="{ backgroundImage: `url(${product.src})` }" />
          <div class="product-info">
            <span>{{ product.description }} | {{ product.subDescription }}</span>
          </div>
          <div class="overlay" @click="openDetail(product)"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-pagination
      v-if="!showDetail"
      background
      layout="prev, pager, next"
      :total="filteredProducts.length"
      :page-size="pageSize"
      :current-page.sync="currentPage"
      @current-change="handlePageChange"
      class="custom-pagination"
    />

    <!-- 替换后的二级页面 -->
    <div v-if="showDetail" class="detail-page">
      <div class="detail-header">
        <span class="detail-category">{{ selectedProduct.description }}</span>
        <span class="detail-title">激光切割图纸 | {{ selectedProduct.subDescription }}</span>
        <el-button class="back-btn" @click="closeDetail">返回</el-button>
      </div>
      <div class="detail-content">
        <div class="main-image-section">
          <img :src="selectedProduct.mainImage" class="main-image" />
          <div class="thumbnail-list">
            <button class="arrow left" @click="prevImage" v-if="selectedProduct.detailedImages.length > 1"> 《 </button>
            <div
              class="thumbnail"
              v-for="(image, idx) in selectedProduct.detailedImages"
              :key="idx"
              :class="{ active: selectedProduct.mainImage === image }"
              @click="updateMainImage(image)"
            >
              <img :src="image" />
            </div>
            <button class="arrow right" @click="nextImage" v-if="selectedProduct.detailedImages.length > 1">》</button>
          </div>
        </div>
        <div class="parameter-card">
          <div class="parameter-title">建议加工参数</div>
          <div class="parameter-list">
            <div class="parameter-row" v-for="(val, key) in selectedProduct.parameters" :key="key">
              <span class="parameter-label">{{ key }}：</span>
              <span class="parameter-value">{{ val }}</span>
            </div>
          </div>
          <div class="detail-btns">
            <el-button type="primary" class="custom-btn" @click="handleDownload(selectedProduct.downloadUrl)">
              <img src="/img/download.png" class="btn-icon" />下载
            </el-button>
            <el-button type="primary" class="custom-btn" @click="handleMake(selectedProduct.makeUrl)">
              <img src="/img/make.png" class="btn-icon" />制作
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 遮罩层提示 -->
    <transition name="fade">
      <div v-if="openingDialog" class="mask-opening">
        <div class="mask-opening-content">
          <img src="/img/make.png" class="mask-opening-icon" />
          <div class="mask-opening-text">软件正在打开中…</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      categories: [
        "全部分类",
        "工艺品",
        "节日装饰",
        "家具用品",
        "动物植物",
        "交通工具",
        "建筑结构",
        "人像雕刻"
      ],
      selectedCategory: "全部分类",
      subCategories: ["图纸", "图片"],
      selectedSubCategory: "图纸",
      searchQuery: "",
      products: [
        {
          src: require('@/assets/城市相框.jpg'),
          description: '工艺品',
          subDescription: '城市相框',
          category: '工艺品',
          type: '图纸',
          detailedImages: [
            require('@/assets/城市相框-1.jpg'),
            require('@/assets/城市相框-2.jpg'),
            require('@/assets/城市相框-3.jpg')
          ],
          parameters: {
            加工宽度: '600mm',
            加工高度: '450mm',
            加工功率: '50%-80%',
            加工速度: '8mm/s',
            加工类型: '切割'
          },
          downloadUrl: '城市相框.svg',
          makeUrl: '城市相框.svg'
        },
        {
          src: require('@/assets/复活节兔子灯-1.jpg'),
          description: '工艺品',
          subDescription: '复活节兔子灯',
          category: '工艺品',
          type: '图纸',
          detailedImages: [
            require('@/assets/复活节兔子灯-1.jpg'),
            require('@/assets/复活节兔子灯-2.jpg'),
            require('@/assets/复活节兔子灯-3.jpg')
          ],
          parameters: {
            加工宽度: '600mm',
            加工高度: '400mm',
            加工功率: '25%-35%',
            加工速度: '22mm/s',
            加工类型: '切割'
          },
          downloadUrl: '复活节兔子灯.svg',
          makeUrl: '复活节兔子灯.svg'
        },
        {
          src: require('@/assets/工艺花架-1.jpg'),
          description: '工艺品',
          subDescription: '工艺花架',
          category: '工艺品',
          type: '图纸',
          detailedImages: [
            require('@/assets/工艺花架-2.jpg'),
            require('@/assets/工艺花架-3.jpg'),
            require('@/assets/工艺花架-4.jpg')
          ],
          parameters: {
            加工宽度: '700mm',
            加工高度: '500mm',
            加工功率: '15%-25%',
            加工速度: '18mm/s',
            加工类型: '雕刻'
          },
          downloadUrl: '工艺花架.svg',
          makeUrl: '工艺花架.svg'
        },
        {
          src: require('@/assets/工艺画-1.jpg'),
          description: '工艺品',
          subDescription: '画',
          category: '工艺品',
          type: '图纸',
          detailedImages: [
            require('@/assets/工艺画-1.jpg'),
            require('@/assets/工艺画-2.png'),
            require('@/assets/工艺画-3.jpg')
          ],
          parameters: {
            加工宽度: '800mm',
            加工高度: '600mm',
            加工功率: '30%-40%',
            加工速度: '25mm/s',
            加工类型: '雕刻'
          },
          downloadUrl: '工艺画.svg',
          makeUrl: '工艺画.svg'
        },
        {
          src: require('@/assets/哈士奇钥匙扣-1.jpg'),
          description: '动物植物',
          subDescription: '哈士奇钥匙扣',
          category: '动物植物',
          type: '图纸',
          detailedImages: [
            require('@/assets/哈士奇钥匙扣-1.jpg'),
            require('@/assets/哈士奇钥匙扣-2.jpg'),
            require('@/assets/哈士奇钥匙扣-3.jpg')
          ],
          parameters: {
            加工宽度: '300mm',
            加工高度: '200mm',
            加工功率: '10%-20%',
            加工速度: '15mm/s',
            加工类型: '切割'
          },
          downloadUrl: '哈士奇钥匙扣.svg',
          makeUrl: '哈士奇钥匙扣.svg'
        },
        {
          src: require('@/assets/瓶中花-1.jpg'),
          description: '工艺品',
          subDescription: '瓶中花',
          category: '工艺品',
          type: '图纸',
          detailedImages: [
            require('@/assets/瓶中花-1.jpg'),
            require('@/assets/瓶中花-2.jpg'),
            require('@/assets/瓶中花-1.jpg')
          ],
          parameters: {
            加工宽度: '300mm',
            加工高度: '200mm',
            加工功率: '10%-20%',
            加工速度: '15mm/s',
            加工类型: '切割'
          },
          downloadUrl: '瓶中花.svg',
          makeUrl: '瓶中花.svg'
        },
        {
          src: require('@/assets/手与花装饰-1.jpg'),
          description: '工艺品',
          subDescription: '手与花装饰',
          category: '工艺品',
          type: '图纸',
          detailedImages: [
            require('@/assets/手与花装饰-1.jpg'),
            require('@/assets/手与花装饰-2.jpg'),
            require('@/assets/手与花装饰-3.jpg')
          ],
          parameters: {
            加工宽度: '300mm',
            加工高度: '200mm',
            加工功率: '10%-20%',
            加工速度: '15mm/s',
            加工类型: '切割'
          },
          downloadUrl: '手与花装饰.svg',
          makeUrl: '手与花装饰.svg'
        },
        {
          src: require('@/assets/圆形矩阵工艺.jpg'),
          description: '工艺品',
          subDescription: '圆形矩阵工艺',
          category: '工艺品',
          type: '图纸',
          detailedImages: [
            require('@/assets/圆形矩阵工艺.jpg'),
            require('@/assets/圆形矩阵工艺.jpg'),
            require('@/assets/圆形矩阵工艺.jpg')
          ],
          parameters: {
            加工宽度: '300mm',
            加工高度: '200mm',
            加工功率: '10%-20%',
            加工速度: '15mm/s',
            加工类型: '切割'
          },
          downloadUrl: '圆形矩阵工艺.svg',
          makeUrl: '圆形矩阵工艺.svg'
        },
        {
          src: require('@/assets/杜宾-1.jpg'),
          description: '动物植物',
          subDescription: '杜宾',
          category: '动物植物',
          type: '图纸',
          detailedImages: [
            require('@/assets/杜宾-1.jpg'),
            require('@/assets/杜宾-2.jpg'),
            require('@/assets/杜宾-3.jpg')
          ],
          parameters: {
            加工宽度: '300mm',
            加工高度: '200mm',
            加工功率: '10%-20%',
            加工速度: '15mm/s',
            加工类型: '切割'
          },
          downloadUrl: 'dubing.svg',
          makeUrl: 'dubing.svg'
        },
        {
          src: require('@/assets/猫窝-1.jpg'),
          description: '动物植物',
          subDescription: '猫窝',
          category: '动物植物',
          type: '图纸',
          detailedImages: [
            require('@/assets/猫窝-1.jpg'),
            require('@/assets/猫窝-2.jpg'),
            require('@/assets/猫窝-3.jpg')
          ],
          parameters: {
            加工宽度: '300mm',
            加工高度: '200mm',
            加工功率: '10%-20%',
            加工速度: '15mm/s',
            加工类型: '切割'
          },
          downloadUrl: '猫窝.svg',
          makeUrl: '猫窝.svg'
        },
        {
          src: require('@/assets/兔子收纳盒-1.jpg'),
          description: '动物植物',
          subDescription: '兔子收纳盒',
          category: '动物植物',
          type: '图纸',
          detailedImages: [
            require('@/assets/兔子收纳盒-1.jpg'),
            require('@/assets/兔子收纳盒-2.jpg'),
            require('@/assets/兔子收纳盒-1.jpg')
          ],
          parameters: {
            加工宽度: '300mm',
            加工高度: '200mm',
            加工功率: '10%-20%',
            加工速度: '15mm/s',
            加工类型: '切割'
          },
          downloadUrl: '兔子收纳盒.svg',
          makeUrl: '兔子收纳盒.svg'
        },
        {
          src: require('@/assets/仙人掌-1.jpg'),
          description: '动物植物',
          subDescription: '仙人掌',
          category: '动物植物',
          type: '图纸',
          detailedImages: [
            require('@/assets/仙人掌-1.jpg'),
            require('@/assets/仙人掌-2.jpg'),
            require('@/assets/仙人掌-3.jpg')
          ],
          parameters: {
            加工宽度: '300mm',
            加工高度: '200mm',
            加工功率: '10%-20%',
            加工速度: '15mm/s',
            加工类型: '切割'
          },
          downloadUrl: '仙人掌.svg',
          makeUrl: '仙人掌.svg'
        },
        {
          src: require('@/assets/小狗-1.png'),
          description: '动物植物',
          subDescription: '小狗',
          category: '动物植物',
          type: '图纸',
          detailedImages: [
            require('@/assets/小狗-1.png'),
            require('@/assets/小狗-2.jpg'),
            require('@/assets/小狗-3.jpg')
          ],
          parameters: {
            加工宽度: '300mm',
            加工高度: '200mm',
            加工功率: '10%-20%',
            加工速度: '15mm/s',
            加工类型: '切割'
          },
          downloadUrl: '小狗.svg',
          makeUrl: '小狗.svg'
        },
        {
          src: require('@/assets/熊猫-1.jpg'),
          description: '动物植物',
          subDescription: '熊猫',
          category: '动物植物',
          type: '图纸',
          detailedImages: [
            require('@/assets/熊猫-1.jpg'),
            require('@/assets/熊猫-2.png'),
            require('@/assets/熊猫-3.png')
          ],
          parameters: {
            加工宽度: '300mm',
            加工高度: '200mm',
            加工功率: '10%-20%',
            加工速度: '15mm/s',
            加工类型: '切割'
          },
          downloadUrl: '熊猫.svg',
          makeUrl: '熊猫.svg'
        },
        {
          src: require('@/assets/郁金香-2.jpg'),
          description: '动物植物',
          subDescription: '郁金香',
          category: '动物植物',
          type: '图纸',
          detailedImages: [
            require('@/assets/郁金香-1.jpg'),
            require('@/assets/郁金香-3.jpg'),
            require('@/assets/郁金香-4.jpg')
          ],
          parameters: {
            加工宽度: '300mm',
            加工高度: '200mm',
            加工功率: '10%-20%',
            加工速度: '15mm/s',
            加工类型: '切割'
          },
          downloadUrl: '郁金香.svg',
          makeUrl: '郁金香.svg'
        }
      ],
      showDetail: false,
      selectedProduct: null,
      currentPage: 1,
      pageSize: 8,
      openingDialog: false,
    };
  },

  methods: {
    filterByCategory(category) {
      this.selectedCategory = category;
    },
    openDetail(product) {
      this.selectedProduct = {
        ...product,
        mainImage: product.detailedImages[0]
      };
      this.showDetail = true;
    },
    closeDetail() {
      this.showDetail = false;
      this.selectedProduct = null;
    },
    updateMainImage(image) {
      this.selectedProduct.mainImage = image;
    },
    handleDownload(fileName) {
      // 下载public/img下的svg文件
      const url = `/img/${fileName}`;
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    handleMake(fileName) {
      this.openingDialog = true;
      window.open(`goodlaser://open?file=${fileName}`, '_blank');
      setTimeout(() => {
        this.openingDialog = false;
      }, 3000);
    },
    handlePageChange(page) {
      this.currentPage = page;
    },
    prevImage() {
      const currentIndex = this.selectedProduct.detailedImages.indexOf(this.selectedProduct.mainImage);
      const prevIndex = (currentIndex - 1 + this.selectedProduct.detailedImages.length) % this.selectedProduct.detailedImages.length;
      this.updateMainImage(this.selectedProduct.detailedImages[prevIndex]);
    },
    nextImage() {
      const currentIndex = this.selectedProduct.detailedImages.indexOf(this.selectedProduct.mainImage);
      const nextIndex = (currentIndex + 1) % this.selectedProduct.detailedImages.length;
      this.updateMainImage(this.selectedProduct.detailedImages[nextIndex]);
    },
  },
  computed: {
    filteredProducts() {
      return this.products.filter((product) => {
        const categoryMatch =
          this.selectedCategory === "全部分类" || product.category === this.selectedCategory;
        const subCategoryMatch = this.selectedSubCategory === product.type;
        const searchMatch = product.subDescription.toLowerCase().includes(this.searchQuery.toLowerCase());
        return categoryMatch && subCategoryMatch && searchMatch;
      });
    },
    pagedProducts() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.filteredProducts.slice(start, start + this.pageSize);
    }
  }
};
</script>

<style scoped>
.product-display {
  padding: 30px;
  background: #ffffff;
  min-height: 100vh;
  border-radius: 20px;
}
.filter-bar {
  width: 100%;
  margin-bottom: 18px;
  background: none;
  /* position: fixed; */
}
.filter-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 15px 0 0 0;
  background: none;
  box-shadow: none;
  border-radius: 0;
  width: 100%;
  margin-left: 0;
}
.categories {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  gap: 24px;
  margin-right: 20px;
}
.categories .el-button {
  background: none;
  border: none;
  color: #333;
  font-size: 16px;
  font-weight: 400;
  padding: 0 8px;
  transition: color 0.2s, border-bottom 0.2s;
}
.categories .el-button.active {
  color: #2ea2fa;
  font-weight: 600;
  border-bottom: 2px solid #2ea2fa;
  border-radius: 0;
}
.search-tools {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
.search-input-group .el-input__inner {
  border-radius: 20px;
  background: #f6faff;
  border: none;
  height: 36px;
  font-size: 15px;
}
.search-input-group .el-input__prefix {
  left: 10px;
}
.search-input-group .el-select {
  border-radius: 20px 0 0 20px;
}
.product-grid {
  margin-top: 24px;
}
.product-card {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(46,162,250,0.10);
  transition: box-shadow 0.2s, transform 0.2s;
  background: #fff;
  margin-bottom: 24px;
  padding: 0 !important;
  cursor: pointer;
}
.product-card:hover {
  box-shadow: 0 4px 20px rgba(46,162,250,0.18);
  transform: translateY(-4px) scale(1.03);
}
.product-image {
  width: 100%;
  aspect-ratio: 4/3;
  background-size: cover;
  background-position: center;
  border-radius: 16px 16px 0 0;
}
.product-info {
  margin-top: 10px;
  font-size: 15px;
  color: #666;
  text-align: center;
  padding-bottom: 12px;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0);
  cursor: pointer;
  z-index: 2;
}
.custom-pagination {
  display: flex;
  justify-content: center;
  margin: 20px 0 0 0;
}
@media (max-width: 1200px) {
  .product-grid .el-col {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (max-width: 700px) {
  .product-grid .el-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
.detail-page {
  background: #fff;
  border-radius: 12px;
  padding: 24px 24px 32px 24px;
  margin: 0 auto;
  width: 90%;
  height: 100%;
  box-shadow: 0 4px 24px rgba(46,162,250,0.08);
  position: relative;
}
.detail-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 18px;
}
.detail-category {
  background: #2ea2fa;
  color: #fff;
  font-size: 14px;
  padding: 2px 12px;
  border-radius: 12px;
  margin-right: 12px;
}
.detail-title {
  font-size: 18px;
  font-weight: 600;
  color: #222;
  flex: 1;
}
.back-btn {
  margin-left: auto;
}
.detail-content {
  display: flex;
  gap: 32px;
}
.main-image-section {
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.main-image {
  width: 100%;
  width: 540px;
  height: 460px;
  object-fit: contain;
  border-radius: 12px;
  background: #f6faff;
  margin-bottom: 16px;
}
.thumbnail-list {
  display: flex;
  align-items: center;
  gap: 12px;
}
.thumbnail {
  width: 126px;
  height: 126px;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid transparent;
  cursor: pointer;
  transition: border 0.2s;
}
.thumbnail.active {
  border: 2px solid #2ea2fa;
}
.thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.arrow {
  background: #f0f7ff;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  font-size: 18px;
  color: #2ea2fa;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.parameter-card {
  width: 40%;
  background: #f6faff;
  border-radius: 12px;
  /* padding: 18px 24px 24px 24px; */
  box-shadow: 0 2px 12px rgba(46,162,250,0.10);
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.parameter-title {
  background: #2ea2fa;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  padding: 15px 0;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  text-align: center;
  margin-bottom: 16px;
}
.parameter-list {
  flex: 1;
  margin-bottom: 18px;
}
.parameter-row {
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  padding: 20px;
  border-bottom: 1px solid #e6f0fa;
}
.parameter-row:last-child {
  border-bottom: none;
}
.parameter-label {
  color: #888;
}
.parameter-value {
  color: #222;
  font-weight: 500;
}
.detail-btns {
  display: flex;
  gap: 18px;
  justify-content: center;
}
.btn-icon {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-right: 6px;
}
.custom-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.mask-opening {
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  z-index: 9999;
  background: rgba(0,0,0,0.32);
  display: flex;
  align-items: center;
  justify-content: center;
}
.mask-opening-content {
  background: rgba(0,0,0,0.12);
  border-radius: 16px;
  padding: 38px 48px 32px 48px;
  box-shadow: 0 4px 24px rgba(46,162,250,0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mask-opening-icon {
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
}
.mask-opening-text {
  font-size: 20px;
  color: #2ea2fa;
  font-weight: 600;
  letter-spacing: 1px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
